import { config } from 'lib-shared-backend-config';

interface MessengerTokenAndUrl {
  messengerToken: string;
  loaderUrl: string;
}

export const messengerTokenMap = {
  dixaSupport: '7c08132d4bf5d5f1bf4432133ef8254e3262f9ef',
  dixaMessengerPlayground: {
    prod: 'cc77864e26984391995ca596e86fb70f',
    stag: 'fa5f3c1f53ba4042abe314656a3caf98',
    stag2: '07359ed9f9c44c0287e189f04d0fd82e',
    stag3: 'ac880e4a42744399a5280bbd80d8fbc1',
  },
  dixaDemo: {
    prod: '95b2b555c0b046a18e5d508837811008',
    stag: '90974320f80c4ea2b07cd33949576f42',
    stag2: '75ba94b9218c475ba82e5f904b6e2c9f',
    stag3: '39a417a8eb134911ae49e8ea3008e3dd',
  },
  shapeOrg: '4c05b2dc879c02d3bb02f14e7585ac6c1ac6146f',
};

export const loaderUrlMap = {
  prod: 'https://messenger.dixa.io/bootstrap.js',
  stag: 'https://messenger.stag.dixa.io/bootstrap.js',
  stag2: 'https://messenger.stag2.dixa.io/bootstrap.js',
  stag3: 'https://messenger.stag3.dixa.io/bootstrap.js',
  dev1: 'https://messenger.dev1.dixa.io/bootstrap.js',
  preprod: 'https://messenger.preprod.dixa.io/bootstrap.js',
};

export function getMessengerWidgetTokenAndUrl(
  backendDomain = config.backendDomain,
): MessengerTokenAndUrl {
  const hostName = window.location.hostname;
  const environment = getEnvironmentFromBackendDomain(backendDomain);

  switch (hostName) {
    case 'neo-messenger-playground.dixa.com':
    case 'messengerplayground.dixa.com':
    case 'engineering.dixa.com':
    case 'localhost': {
      return {
        messengerToken: messengerTokenMap.dixaMessengerPlayground[environment],
        loaderUrl: loaderUrlMap[environment],
      };
    }
    case 'demo.dixa.com': {
      return {
        messengerToken: messengerTokenMap.dixaDemo[environment],
        loaderUrl: loaderUrlMap[environment],
      };
    }
    case 'shape.dixa.com': {
      return {
        messengerToken: messengerTokenMap.shapeOrg,
        loaderUrl: loaderUrlMap[environment],
      };
    }
    default: {
      return {
        messengerToken: messengerTokenMap.dixaSupport,
        loaderUrl: loaderUrlMap.prod,
      };
    }
  }
}

function getEnvironmentFromBackendDomain(backendDomain: string | null) {
  if (backendDomain?.includes('dev1')) {
    return 'dev1';
  }
  if (backendDomain?.includes('preprod')) {
    return 'preprod';
  }
  if (backendDomain?.includes('stag3')) {
    return 'stag3';
  }
  if (backendDomain?.includes('stag2')) {
    return 'stag2';
  }
  if (backendDomain?.includes('stag')) {
    return 'stag';
  }
  return 'prod';
}
